export default function () {
    const target = $(".minicart-quantity.counter");
    var hiddenCounter = $(".minicart-quantity.hidden");
    var config = { attributes: false, childList: true, characterData: true };

    var observer = new MutationObserver(function () {
        if (parseInt(hiddenCounter.text(), 10) > 99) {
            target.text("99+");
        }
    });
    if (hiddenCounter.length > 0) {
        observer.observe(hiddenCounter[0], config);
    }
}
